import {ApiCollection} from "./api.collection";
import {Status} from "../models/status.model";


export const Statuses = ApiCollection.extend({
    model: Status,
    url: 'api/statuses',
});
